export const home = {
  heroTitle: "Sell your stuff in",
  heroTitleAccent: "seconds",
  heroSubtitle: "Take a photo – you get a finished listing text and a price suggestion.",
  draftSaved: "You have a saved draft.",
  draftContinue: "Continue where you left off",
  sheetTitle: "What do you want to sell?",
  sheetDescription: "Choose how you want to get started.",
  ctaTitle: "Photograph your item – we write the listing",
  ctaSubtitle: "Take a picture – you get the text and a price suggestion, and publish for free.",
  ctaButton: "Get started",
  latestTitle: "Latest listings",
  latestSubtitle: "From all over the country.",
  seeAll: "See all listings",
  empty: "No listings yet — be the first to publish one.",
} as const;
